import { useEffect, useRef } from 'react';

/**
 * Runs the supplied refresh callback on a fixed interval while preventing overlapping refreshes.
 */
export const useAutoRefresh = (
    enabled: boolean,
    refresh: () => Promise<void> | void,
    intervalMs = 60000
) => {
    const refreshRef = useRef(refresh);
    const isRefreshingRef = useRef(false);

    useEffect(() => {
        refreshRef.current = refresh;
    }, [refresh]);

    useEffect(() => {
        if (!enabled) {
            return undefined;
        }

        const intervalId = window.setInterval(() => {
            if (isRefreshingRef.current) {
                return;
            }

            isRefreshingRef.current = true;
            Promise.resolve(refreshRef.current())
                .finally(() => {
                    isRefreshingRef.current = false;
                });
        }, intervalMs);

        return () => window.clearInterval(intervalId);
    }, [enabled, intervalMs]);
};
